function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0H90V60H0V0Z",
  fill: "#D60A2E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3427 10.9453L17.3594 17.0581L24.1045 18.038L19.2232 22.796L20.376 29.5146L14.3427 26.3424L8.30851 29.5146L9.46138 22.796L4.58008 18.038L11.3252 17.0581L14.3427 10.9453Z",
  fill: "#FED953"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M32.2111 22.6777L33.417 25.12L36.1125 25.5115L34.1618 27.4134L34.622 30.0973L32.2111 28.8303L29.8003 30.0973L30.2604 27.4134L28.3105 25.5115L31.0061 25.12L32.2111 22.6777Z",
  fill: "#FED953"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30.784 11.998L32.9872 13.6003L35.5553 12.6941L34.7119 15.2845L36.368 17.4471L33.6443 17.4454L32.0983 19.6883L31.2583 17.097L28.6479 16.3207L30.8519 14.7209L30.784 11.998Z",
  fill: "#FED953"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M27.251 4.62793L26.7362 7.3028L28.648 9.24357L25.945 9.58041L24.6903 11.9979L23.5349 9.53159L20.8477 9.08467L22.8364 7.22335L22.4301 4.53027L24.8153 5.84619L27.251 4.62793Z",
  fill: "#FED953"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M27.251 32.0327L26.7362 34.7076L28.648 36.6475L25.945 36.9844L24.6903 39.4019L23.5349 36.9355L20.8477 36.4895L22.8364 34.6281L22.4301 31.9351L24.8153 33.251L27.251 32.0327Z",
  fill: "#FED953"
});

var SvgCnh = function SvgCnh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCnh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CNH.a02884b0.svg";
export { ForwardRef as ReactComponent };